import PropTypes from 'prop-types';
import React from 'react';
import { Button, Image, FormGroup, FormControl, HelpBlock } from 'react-bootstrap';

const searchDelay = 1000;

class SearchHotelForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleEnterKey = this.handleEnterKey.bind(this);
    this.state = {
      search: props.search,
      save: false,
    };
  }
  componentWillMount() {
    this.timer = null;
  }
  handleChange(e) {
    e.preventDefault();
    // clearTimeout(this.timer);
    this.setState({
      search: e.target.value,
      save: true,
    });
    // this.timer = setTimeout(this.triggerSearch, searchDelay);
  }
  handleEnterKey(e) {
    if (e.keyCode === 13) this.handleSearch();
  }
  handleSearch() {
    if (this.state.search) {
      console.log('Go search: ', this.state.search);
      this.props.requestHotelSearch(this.state.search);
    }
  }

  render() {
    return (
      <div>
        <FormGroup controlId="hotel-search">
          <FormControl
            type="text"
            value={this.state.search}
            placeholder="Search Hotel Name and City"
            onChange={this.handleChange}
            onKeyDown={this.handleEnterKey}
          />
          <Button onClick={this.handleSearch}>Search</Button>
        </FormGroup>
      </div>
    );
  }
}

SearchHotelForm.propTypes = {
  search: PropTypes.string,
  requestHotelSearch: PropTypes.func.isRequired,
};
SearchHotelForm.defaultProps = {
  search: null,
};

export default SearchHotelForm;



// WEBPACK FOOTER //
// src/routes/hotels/components/SearchHotelForm.js